export default "__VITE_ASSET__3760ab00__"